// https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3751215124/BSB+Enums

export enum SecFEPermissionPartnerAppEnum {

    PAU = 'PAU',

    // helpers start with __ and connect/group several permissions together
    __PAU_CONTRACTS = '__PAU_CONTRACTS',  // enabled if any PAU_CONTRACTS_* permission is granted, used to control csp parent menu item visibility


    __PAU_CONTRACTS_CSP = '__PAU_CONTRACTS_CSP',  // enabled if PAU_CONTRACTS_CSP_EDIT or PAU_CONTRACTS_CSP_EDIT is granted

    PAU_CONTRACTS_CSP_EDIT = 'PAU_CONTRACTS_CSP_EDIT',
    PAU_CONTRACTS_CSP_READONLY = 'PAU_CONTRACTS_CSP_READONLY' ,


    PAU_CONTRACTS_CSP_CONNECTED = 'PAU_CONTRACTS_CSP_CONNECTED',


    PAU_PROJECTS = 'PAU_PROJECTS',

    PAU_SERVICE = 'PAU_SERVICE',


    MY_USER_MANAGEMENT = 'MY_USER_MANAGEMENT',
}
